<div class="limit-notification" *ngIf="visible" [@slideDown]>
  <div>
    <div class="limit-header">
      <div class="limit-icon">
        <img src="../../../../assets/images/warning/SVGRepo_iconCarrier.svg" alt="">
      </div>
      <div class="limit-title">{{ title }}</div>
    </div>

    <div class="limit-message">
      {{ message }}
    </div>

    <button
      *ngIf="actionLabel"
      class="upgrade-btn"
      (click)="onAction()">
      <span>{{ actionLabel }}</span>
    </button>
  </div>

  <div>
    <button class="close-btn" (click)="close()">
      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 1L13 13M1 13L13 1"
          stroke="#9CA3AF"
          stroke-width="2"
          stroke-linecap="round" />
      </svg>
    </button>
  </div>
</div>
